/**
 * Token mapper
 * @returns the mapper for token
 */
export const tokenMapper = () => {
  return {
    'token-read': ['auth/tokens:read'],
    'token-write': ['auth/tokens:read', 'auth/tokens:write'],
  };
};

/**
 * User mapper
 * @returns the mapper for user
 */
export const userMapper = () => {
  return {
    'user-read': ['auth/users:read'],
    'user-write': ['auth/users:read', 'auth/users:write'],
  };
};

/**
 * Client mapper
 * @returns the mapper for client (incl. private-credential reveal)
 */
export const clientMapper = () => {
  return {
    'client-read': ['auth/clients:read'],
    'client-write': ['auth/clients:read', 'auth/clients:write'],
    'client-private': ['auth/clients:read:private'],
  };
};

/**
 * Market mapper
 * @returns the mapper for market area
 */
export const marketMapper = () => {
  return {
    'market-area-read': ['auth/market-areas:read'],
    'market-area-write': ['auth/market-areas:read', 'auth/market-areas:write'],
  };
};
